import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useRef,
  useCallback,
  useContext,
} from "react";
import api from "../api/axios";
import "./Scss/ContactStyles.scss?v=1.1.3";
// Animations
import {
  Alert,
  Autocomplete,
  Fade,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
// COMPONENTS
import { Grid, TextField, Button } from "@mui/material";
import ReactPaginate from "react-paginate";
// DATEPICKER
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// DATEPICKER
// MANUAL COMPONENTS
import Table from "../Components/Common/Table/Table";
// FUNCTIONS
import { CircularProgress, LinearProgress } from "@mui/material/";

import { CommonSubHeader, handleDates } from "../Components/helpers/Helpers";
import LoadingPage from "../Components/Common/Loading/LoadingPage";
import { RenderCell } from "../Components/Common/Table/RenderCell";
import {
  CleaningServices,
  Delete,
  PersonAdd,
  Search,
} from "@mui/icons-material";
import TableActions from "../Components/Common/Table/TableActions";
import { CustomButtonPlusIcon } from "../Components/Common/Design/CustomButtonPlusIcon";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PermissionContext } from "../Components/Context/Context";
import { hasPermission } from "../Components/Context/helpers/permissions";
import Unauthorized from "../Components/Common/Design/Unauthorized";

function Contactos(props) {
  // SweetAlert
  const Swal = require("sweetalert2");
  const hasMounted = useRef(false);
  const { can } = useContext(PermissionContext);
  const hasPermission = can("contacts", "view");

  //Resultados por pagina.
  const [contact, setContact] = useState([]);
  const [urlSetted, setUrlSetted] = useState("");
  const [objPerPage, setObjPerPage] = useState(10);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pagePressed, setPagePressed] = useState(1);
  const [flag, setFlag] = useState(false);
  const [dataNoResults, setDataNoResults] = useState(false);
  const [search, setSearch] = useState(false);

  const [stateDelete, setStateDelete] = useState(false);

  // Columns data input filters
  const [assignId, setAssignId] = useState({
    name: "Seleccionar",
    surname: "",
  });
  const [caseTypeId, setCaseTypeId] = useState({
    case_type: "Seleccionar",
    id: 0,
  });
  const [statusId, setStatusId] = useState(0);
  const [companyId, setCompanyId] = useState({
    company_name: "Seleccionar",
    id: 0,
  });
  const [asociationId, setAsociationId] = useState({
    asoc_name: "Seleccionar",
    id: 0,
  });

  // MANEJO DE FILTROS
  const [queryName, setQueryName] = useState(false);
  const [querySurname, setQuerySurname] = useState(false);
  const [queryPhone, setQueryPhone] = useState(false);
  const [queryEmail, setQueryEmail] = useState(false);
  const [queryProvince, setQueryProvince] = useState(false);
  const [queryObjPerPage, setQueryObjPerPage] = useState(false);

  const [provinceFilter, setProvinceFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [surnameFilter, setSurnameFilter] = useState("");
  const [phoneFilter, setPhoneFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  // MANEJO DE FILTROS

  // DATEPICKER
  const [dateInDefault, setDateInDefault] = useState();
  const [dateInFilter, setDateInFilter] = useState(0);
  const [dateFromRangeFilter, setDateFromRangeFilter] = useState(0);
  const [dateFromDefault, setDateFromDefault] = useState();
  const [dateToRangeFilter, setDateToRangeFilter] = useState(0);
  const [dateToDefault, setDateToDefault] = useState();
  // DATEPICKER

  // LISTAS PARA SELECTS FILTERS
  const [openOptionsCaseTypes, setOpenOptionsCaseTypes] = useState(false);
  const [openOptionsStatus, setOpenOptionsStatus] = useState(false);
  const [openOptionsChangeStatus, setOpenOptionsChangeStatus] = useState(false);
  const [openOptionsAsignTo, setOpenOptionsAsignTo] = useState(false);
  const [openOptionsCompanies, setOpenOptionsCompanies] = useState(false);
  const [openOptionsAsociations, setOpenOptionsAsociations] = useState(false);

  const [optionsCaseTypes, setOptionsCaseTypes] = useState([]);
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [optionsChangeStatus, setOptionsChangeStatus] = useState([]);
  const [optionsAsignTo, setOptionsAsignTo] = useState([]);
  const [optionsCompanies, setOptionsCompanies] = useState([]);
  const [optionsAsociations, setOptionsAsociations] = useState([]);

  const loadingOptionsCaseTypes =
    openOptionsCaseTypes && optionsCaseTypes.length === 0;
  const loadingOptionsStatus = openOptionsStatus && optionsStatus.length === 0;
  const loadingOptionsChangeStatus =
    openOptionsChangeStatus && optionsChangeStatus.length === 0;
  const loadingOptionsAsignTo =
    openOptionsAsignTo && optionsAsignTo.length === 0;
  const loadingOptionsCompanies =
    openOptionsCompanies && optionsCompanies.length === 0;
  const loadingOptionsAsociations =
    openOptionsAsociations && optionsAsociations.length === 0;
  // LISTAS PARA SELECTS FILTERS

  /// Checkboxes
  const [deletedSuccess, setDeletedSuccess] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [contactNewState, setContactNewState] = useState(false);
  const [changeStateResponse, setChangeStateResponse] = useState(false);
  const [changeDone, setChangeDone] = useState(false);
  const [flagToChangeStateHidePaginator, setFlagToChangeStateHidePaginator] =
    useState(false);
  /// Checkboxes
  const [showStatusColumn, setShowStatusColumn] = useState(false); // Cambia a false para ocultar la columna de estado

  const getDataContacts = useCallback(async () => {
    setFlag(true);
    try {
      const response = await api.post(
        process.env.REACT_APP_API_URL + `/contacts`,
        {
          page: pagePressed,
          objPerPage,
          caseType: caseTypeId.id,
          contactStatus: statusId.id,
          companySelected: companyId.id,
          asociationSelected: asociationId.id,
          assignedName: assignId.name,
          assignedSurname: assignId.surname,
          name: queryName,
          surname: querySurname,
          phone: queryPhone,
          email: queryEmail,
          province: queryProvince,
          dateIn: dateInFilter,
          dateInRange: dateFromRangeFilter,
          dateToRange: dateToRangeFilter,
        },
      );

      console.log(response);
      const { status, contacts, cases_type, companies, associations, lawyers } =
        response.data;

      const contactsData = contacts.data;

      contactsData.forEach((contact) => {
        if (contact.lawyers_relation.id !== 0) {
          contact.lawyers_fullname = `${contact.lawyers_relation.name} ${contact.lawyers_relation.surname}`;
        }

        if (contact.assigned_relation.id !== 0) {
          contact.assigned_fullname = `${contact.assigned_relation.name} ${contact.assigned_relation.surname}`;
        }

        contact.status_name = getStatusName(contact.status);

        if (contact.name !== "" || contact.surname !== "") {
          contact.contact_fullname = `${contact.name} ${contact.surname}`;
        }
      });

      setOptions(cases_type, companies, lawyers, associations);

      setPageCount(contacts.last_page);
      setTotalPagesNumber(contacts.total);
      setContact(contactsData);
      setFlag(false);

      if (contacts.total === 0) {
        setDataNoResults(true);
      } else {
        setDataNoResults(false);
      }
    } catch (error) {
      console.error(
        "Ha ocurrido un error en la respuesta del servidor - tabla contactos:",
        error,
      );
    } finally {
      setFlag(false); // Asegúrate de restablecer el flag en caso de error
    }
  }, [
    pagePressed,
    objPerPage,
    search,
    changeDone,
    // caseTypeId,
    // statusId,
    // companyId,
    // asociationId,
    // assignId,
    // queryName,
    // querySurname,
    // queryPhone,
    // queryEmail,
    // queryProvince,
    // dateInFilter,
    // dateFromRangeFilter,
    // dateToRangeFilter,
  ]);

  const handleFilterStates = () => {
    setCaseTypeId({ case_type: "Seleccionar", id: 0 });
    setCompanyId({ company_name: "Seleccionar", id: 0 });
    setAssignId({ name: "Seleccionar", surname: "" });
    setAsociationId({ asoc_name: "Seleccionar", id: 0 });
    setStatusId({ nombre: "Seleccionar", id: 0 });

    // MANEJO DE FILTROS
    setQueryName("");
    setQuerySurname("");
    setQueryPhone("");
    setQueryEmail("");
    setQueryProvince("");

    setProvinceFilter("");
    setNameFilter("");
    setSurnameFilter("");
    setPhoneFilter("");
    setEmailFilter("");
    // MANEJO DE FILTROS

    // // DATEPICKER
    setDateInDefault(null);
    setDateInFilter("");
    setDateFromRangeFilter("");
    setDateFromDefault(null);
    setDateToRangeFilter("");
    setDateToDefault(null);

    setSearch(!search);
  };

  // Función para obtener el nombre del estado
  const getStatusName = (status) => {
    const statusNames = {
      0: "Pte Llamada",
      1: "Llamado",
      2: "Cliente",
      3: "Cancelado",
    };
    return statusNames[status] || "";
  };

  // Función para establecer las opciones
  const setOptions = (casesTypes, companies, lawyers, associations) => {
    casesTypes.unshift({ case_type: "Seleccionar", id: 0 });
    companies.unshift({ company_name: "Seleccionar", id: 0 });
    lawyers.unshift({ name: "Seleccionar", surname: "" });
    associations.unshift({ asoc_name: "Seleccionar", id: 0 });

    const arrayToStatus = [
      { nombre: "Seleccionar", id: 0 },
      { nombre: "Pte Llamada", id: -1 },
      { nombre: "Llamado", id: 1 },
      { nombre: "Cliente", id: 2 },
      { nombre: "Cancelado", id: 3 },
    ];

    setOptionsAsignTo(lawyers);
    setOptionsCaseTypes(casesTypes);
    setOptionsCompanies(companies);
    setOptionsAsociations(associations);
    setOptionsStatus(arrayToStatus);
    setOptionsChangeStatus(arrayToStatus);
  };

  const handleChangeDateIn = (newValue) => {
    console.log(newValue); // Verifica si esto es un objeto dayjs
    if (newValue && dayjs.isDayjs(newValue)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = newValue.format("YYYY-MM-DD 00:00:00");
      setDateInDefault(newValue); // Guarda solo la fecha como string
      setDateInFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateInFilter(null);
      console.error("El nuevo valor no es un objeto dayjs");
    }
  };

  const handleChangeDateFromRange = (dateFrom) => {
    console.log(dateFrom); // Verifica si esto es un objeto dayjs
    if (dateFrom && dayjs.isDayjs(dateFrom)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = dateFrom.format("YYYY-MM-DD 00:00:00");
      setDateFromDefault(dateFrom); // Guarda solo la fecha como string
      setDateFromRangeFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateFromRangeFilter(null);
    }
  };

  const handleChangeDateToRange = (dateTo) => {
    console.log(dateTo); // Verifica si esto es un objeto dayjs
    if (dateTo && dayjs.isDayjs(dateTo)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = dateTo.format("YYYY-MM-DD 23:59:59");
      setDateToDefault(dateTo); // Guarda solo la fecha como string
      setDateToRangeFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateToRangeFilter(null);
    }
  };

  const handlePageClick = (event) => {
    console.log(event.selected);
    setPagePressed(event.selected + 1);
  };

  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getDataContacts();
  }, [getDataContacts]);

  useEffect(() => {
    if (typeof queryObjPerPage == "string") {
      if (totalPagesNumber < queryObjPerPage) {
        setObjPerPage(totalPagesNumber);
      } else {
        setObjPerPage(queryObjPerPage);
      }
    }
  }, [queryObjPerPage]);
  // FILTERS

  // SELECTS
  useEffect(() => {
    let activeOptionsCaseTypes = true;
    if (!loadingOptionsCaseTypes) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsCaseTypes) {
        setOptionsCaseTypes([...openOptionsCaseTypes]);
      }
    }, "200");
  }, [loadingOptionsCaseTypes]);

  useEffect(() => {
    let activeOptionsStatus = true;
    if (!loadingOptionsStatus) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsStatus) {
        setOptionsStatus([...openOptionsStatus]);
      }
    }, "200");
  }, [loadingOptionsStatus]);

  useEffect(() => {
    let activeOptionsAsignTo = true;
    if (!loadingOptionsAsignTo) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsAsignTo) {
        setOptionsAsignTo([...openOptionsAsignTo]);
      }
    }, "200");
  }, [loadingOptionsAsignTo]);

  useEffect(() => {
    let activeOptionsCompanies = true;
    if (!loadingOptionsCompanies) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsCompanies) {
        setOptionsCompanies([...openOptionsCompanies]);
      }
    }, "200");
  }, [loadingOptionsCompanies]);

  useEffect(() => {
    let activeOptionsAsociations = true;
    if (!loadingOptionsAsociations) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsAsociations) {
        setOptionsAsociations([...openOptionsAsociations]);
      }
    }, "200");
  }, [loadingOptionsAsociations]);

  // END SELECTS

  const renderStatus = (estado) => {
    switch (estado) {
      case 0:
        return "Pte. Llamada";
      case 1:
        return "Llamado";
      case 2:
        return "Cliente";
      case 3:
        return "Cancelado";
      default:
        return "Sin asignar";
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: `LISTA DE CONTACTOS`,
        columns: [
          {
            Header: "Asignado a",
            accessor: "assigned_fullname",
            width: 120,
            maxWidth: 200,
            minWidth: 120,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Fecha de Entrada",
            accessor: "date_in",
            width: 140,
            maxWidth: 200,
            minWidth: 140,
            Cell: ({ row, value }) => (
              <RenderCell value={value} dateFlag={true} view="contactos" />
            ),
          },
          {
            Header: "Tipo de caso",
            accessor: "types_relation.case_type",
            width: 140,
            maxWidth: 200,
            minWidth: 140,
            Cell: ({ row, value }) => (
              <RenderCell value={value} dateFlag={true} view="contactos" />
            ),
          },
          {
            Header: "Actualizado",
            accessor: "date_update",
            width: 140,
            maxWidth: 200,
            minWidth: 140,
            Cell: ({ row, value }) => (
              <RenderCell value={value} dateFlag={true} view="contactos" />
            ),
          },
          {
            Header: "Estado",
            accessor: "status",
            width: 85,
            maxWidth: 200,
            minWidth: 110,
            Cell: ({ row }) => (
              <div className="spanClassForTables centerContent">
                {renderStatus(row.original.status)}
              </div>
            ),
          },
          {
            Header: "Empresa",
            accessor: "company_relation.company_name",
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Asociación",
            accessor: "asociations_relation.asoc_name",
            width: 300,
            minWidth: 150,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Provincia",
            accessor: "province",
            width: 100,
            maxWidth: 200,
            minWidth: 100,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Nombre y Apellidos",
            accessor: "contact_fullname",
            width: 166,
            maxWidth: 200,
            minWidth: 166,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Teléfono",
            accessor: "phone",
            width: 80,
            maxWidth: 200,
            minWidth: 80,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Email",
            accessor: "email",
            width: 174,
            maxWidth: 200,
            minWidth: 174,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Acciones",
            accessor: "id",
            minWidth: 174,
            Cell: ({ value }) => (
              <TableActions
                rute={"contactos"}
                value={value}
                showView
                showEdit
                showDelete
                module={"contacts"}
                apiRute={"contacts"}
                setChangeDone={setChangeDone}
                changeDone={changeDone}
              />
            ),
          },
        ],
      },
    ],
    [],
  );

  useEffect(() => {
    setFlagToChangeStateHidePaginator(selectedRowIds.length !== 0);
  }, [selectedRowIds]);

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  // NEW STATE
  const handleCheckBoxesToChangeState = async (val) => {
    const valuesSelected = [...selectedRowIds];

    if (
      !valuesSelected ||
      valuesSelected === "" ||
      valuesSelected === 0 ||
      valuesSelected.length === 0
    ) {
      Swal.fire(
        "¡Error!",
        "No hay contactos seleccionados para actualizar.",
        "warning",
      );
      return;
    }
    if (contactNewState === 0 || contactNewState === false) {
      Swal.fire(
        "¡Error!",
        "No se ha seleccionado ningún estado nuevo.",
        "warning",
      );
      return;
    }

    if (val == "changeStatus") {
      const queryUrl = `${process.env.REACT_APP_API_URL}/contacts/updatecontactstate`;

      try {
        const result = await Swal.fire({
          icon: "warning",
          title: "¿Desea guardar los cambios?",
          showDenyButton: true,
          confirmButtonColor: "#1ab394",
          cancelButtonColor: "#d33",
          reverseButtons: true,
          confirmButtonText: "Guardar",
          denyButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
          const response = await api.post(queryUrl, {
            contactIds: JSON.stringify(valuesSelected),
            contactNewState: contactNewState,
          });

          if (response.data.response > 0) {
            setChangeStateResponse(!changeStateResponse);
            setFlagToChangeStateHidePaginator(false);
            Swal.fire({
              html: "¡Guardado!",
              icon: "success",
              confirmButtonColor: "#1ab394",
              confirmButtonText: "Continuar",
            }).then((result) => {
              setSearch(!search);
            });
            // timer: 1500, // Opcional: cierra automáticamente la alerta después de 1.5 segundos
          } else {
            Swal.fire({
              title:
                "¡No se han registrado cambios o ha seleccionado el mismo estado!",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1ab394",
            });
          }
        } else if (result.isDenied) {
          Swal.fire("¡Los cambios no han sido guardados!", "", "info");
        }
      } catch (error) {
        console.error("Error al actualizar el estado de los contactos:", error);
        Swal.fire(
          "¡Error!",
          "Ha ocurrido un problema al intentar actualizar el estado.",
          "error",
        );
      }
    } else if (val == "delete") {
    }
  };

  //   Configuración de campos Autocomplete
  const autocompleteFilters = [
    {
      label: "Asignado a",
      value: assignId,
      setValue: (value) =>
        value
          ? setAssignId({ name: value.name, surname: value.surname })
          : setAssignId({ name: "Seleccionar", surname: "" }),
      open: openOptionsAsignTo,
      setOpen: setOpenOptionsAsignTo,
      options: optionsAsignTo,
      loading: loadingOptionsAsignTo,
      getOptionLabel: (option) => `${option.name} ${option.surname}`,
      isOptionEqualToValue: (option, value) => option.id === value.id,
      className: "asignToId",
    },
    {
      label: "Tipo de caso",
      value: {
        case_type: caseTypeId.case_type || "Seleccionar",
        id: caseTypeId.id || 0,
      },
      setValue: (value) => (value ? setCaseTypeId(value) : setCaseTypeId(0)),
      open: openOptionsCaseTypes,
      setOpen: setOpenOptionsCaseTypes,
      options: optionsCaseTypes,
      loading: loadingOptionsCaseTypes,
      getOptionLabel: (option) => option.case_type,
      isOptionEqualToValue: (option, value) => option.id === value.id,
      className: "caseTypeId",
    },
    {
      label: "Estado",
      value: {
        nombre: statusId.nombre || "Seleccionar",
        id: statusId.id || 0,
      },
      setValue: (value) => setStatusId(value || null),
      open: openOptionsStatus,
      setOpen: setOpenOptionsStatus,
      options: optionsStatus,
      loading: loadingOptionsStatus,
      getOptionLabel: (option) => option.nombre,
      isOptionEqualToValue: (option, value) => option.nombre === value.nombre,
      className: "statusId",
    },
    {
      label: "Empresa",
      value: {
        company_name: companyId.company_name || "Seleccionar",
        id: companyId.id || 0,
      },
      setValue: (value) => (value ? setCompanyId(value) : setCompanyId(0)),
      open: openOptionsCompanies,
      setOpen: setOpenOptionsCompanies,
      options: optionsCompanies,
      loading: loadingOptionsCompanies,
      getOptionLabel: (option) => option.company_name,
      isOptionEqualToValue: (option, value) => option.id === value.id,
      className: "companyId",
    },
    {
      label: "Asociaciones",
      value: {
        asoc_name: asociationId.asoc_name || "Seleccionar",
        id: asociationId.id || 0,
      },
      setValue: (value) =>
        value ? setAsociationId(value) : setAsociationId(0),
      open: openOptionsAsociations,
      setOpen: setOpenOptionsAsociations,
      options: optionsAsociations,
      loading: loadingOptionsAsociations,
      getOptionLabel: (option) => option.asoc_name,
      isOptionEqualToValue: (option, value) => option.id === value.id,
      className: "asociationsId",
    },
  ];

  //   Campos de texto
  const textFilters = [
    { label: "Provincia", value: queryProvince, setValue: setQueryProvince },
    { label: "Nombre contacto", value: queryName, setValue: setQueryName },
    {
      label: "Apellido contacto",
      value: querySurname,
      setValue: setQuerySurname,
    },
    { label: "Teléfono", value: queryPhone, setValue: setQueryPhone },
    { label: "Email", value: queryEmail, setValue: setQueryEmail },
  ];

  //   Rango de fechas
  const dateRangeFilters = [
    {
      label: "Fecha entrada desde",
      value: dateFromDefault ? dayjs(dateFromDefault) : null,
      onChange: (date) => handleChangeDateFromRange(date),
      sx: {
        width: "50%",
        "& fieldset": {
          borderRight: "none",
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        },
      },
      className: "rangeFilterDateLeft",
    },
    {
      label: "Fecha entrada hasta",
      value: dateToDefault ? dayjs(dateToDefault) : null,
      onChange: (date) => handleChangeDateToRange(date),
      sx: {
        width: "50%",
        "& fieldset": {
          borderLeft: "none",
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        },
      },
      className: "rangeFilterDateRight",
    },
  ];

  const ChangeStatusBlock = (
    <div style={{ display: "flex", gap: "8px", padding: "0px 10px" }}>
      <Autocomplete
        className="changeStatusId noBorderRadius inputsFont"
        size="small"
        sx={{ width: 220 }}
        onChange={(e, value) => {
          if (value) {
            setContactNewState(value.id);
            setShowStatusColumn(true);
          } else {
            setContactNewState(-1);
            setShowStatusColumn(false);
          }
        }}
        open={openOptionsChangeStatus}
        onOpen={() => setOpenOptionsChangeStatus(true)}
        onClose={() => setOpenOptionsChangeStatus(false)}
        isOptionEqualToValue={(o, v) => o.nombre === v.nombre}
        getOptionLabel={(o) => o.nombre}
        options={optionsChangeStatus}
        loading={loadingOptionsChangeStatus}
        renderInput={(params) => (
          <TextField {...params} label="Cambiar estado" />
        )}
      />

      <Button
        onClick={() => handleCheckBoxesToChangeState("changeStatus")}
        className="noBorderRadius inputsFont"
        variant="outlined"
        size="small"
        color="primary">
        Cambiar
      </Button>
    </div>
  );

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Contactos" />

      <div className="mainContainer">
        <div className="subMainContainer">
          {!hasPermission && <Unauthorized />}

          {hasPermission && (
            <Grid
              container
              item
              xs={12}
              direction="row"
              className="filtersContainer">
              {/*  Autocompletes */}
              {autocompleteFilters.map((field, i) => (
                <Grid key={i} item xs={4} md={2} sx={{ p: "5px" }}>
                  <Autocomplete
                    disabled={flagToChangeStateHidePaginator}
                    className={`${field.className} noBorderRadius inputsFont`}
                    size="small"
                    value={field.value}
                    onChange={(e, v) => field.setValue(v)}
                    open={field.open}
                    onOpen={() => field.setOpen(true)}
                    onClose={() => field.setOpen(false)}
                    options={field.options}
                    isOptionEqualToValue={field.isOptionEqualToValue}
                    getOptionLabel={field.getOptionLabel}
                    loading={field.loading}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={field.label}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {field.loading && (
                                <CircularProgress color="inherit" size={20} />
                              )}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
              ))}

              {/* Campo de fecha única */}
              <Grid item xs={4} md={2} sx={{ p: "5px" }}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="es">
                  <DesktopDatePicker
                    disabled={flagToChangeStateHidePaginator}
                    className="noBorderRadius inputsFont"
                    renderInput={(props) => <TextField {...props} />}
                    label="Fecha de entrada"
                    sx={{ width: "100%" }}
                    onChange={(value) => handleChangeDateIn(value)}
                    inputFormat="DD/MM/YYYY"
                    value={dateInDefault ? dayjs(dateInDefault) : null}
                  />
                </LocalizationProvider>
              </Grid>

              {/*  TextFields */}
              {textFilters.map((item, i) => (
                <Grid key={i} item xs={4} md={2} sx={{ p: "5px" }}>
                  <TextField
                    disabled={flagToChangeStateHidePaginator}
                    className="noBorderRadius inputsFont"
                    onChange={(e) => item.setValue(e.target.value)}
                    label={item.label}
                    variant="outlined"
                    autoComplete="new-password"
                    size="small"
                    sx={{ width: "100%" }}
                    value={item.value || ""}
                  />
                </Grid>
              ))}

              <Grid item xs={4} md={2} sx={{ p: "5px" }}>
                <FormControl
                  fullWidth
                  size="small"
                  disabled={flagToChangeStateHidePaginator}>
                  <InputLabel id="per-page-label">Nº Registros</InputLabel>

                  <Select
                    labelId="per-page-label"
                    value={objPerPage}
                    label="Nº Registros"
                    onChange={(e) => setQueryObjPerPage(e.target.value)}>
                    {[10, 20, 30, 100, 200].map((num) => (
                      <MenuItem key={num} value={num}>
                        {num}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/*  Rango de fechas */}
              <Grid item xs={12} md={8} sx={{ p: "5px" }}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="es">
                  {dateRangeFilters.map((item, i) => (
                    <DesktopDatePicker
                      key={i}
                      sx={item.sx}
                      disabled={flagToChangeStateHidePaginator}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className={item.className}
                          style={{ width: "50%" }}
                        />
                      )}
                      label={item.label}
                      value={item.value}
                      onChange={item.onChange}
                    />
                  ))}
                </LocalizationProvider>
              </Grid>

              {/* x Cambiar estado
            <Grid
              item
              xs={6}
              md={4}
              sx={{ p: "5px", display: "flex", gap: "5px" }}>
              <Autocomplete
                className="changeStatusId noBorderRadius inputsFont"
                size="small"
                sx={{ width: "100%" }}
                onChange={(e, value) => {
                  if (value) {
                    setContactNewState(value.id);
                    setShowStatusColumn(true);
                  } else {
                    setContactNewState(-1);
                    setShowStatusColumn(false);
                  }
                }}
                open={openOptionsChangeStatus}
                onOpen={() => setOpenOptionsChangeStatus(true)}
                onClose={() => setOpenOptionsChangeStatus(false)}
                isOptionEqualToValue={(o, v) => o.nombre === v.nombre}
                getOptionLabel={(o) => o.nombre}
                options={optionsChangeStatus}
                loading={loadingOptionsChangeStatus}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cambiar estado"
                    autoComplete="off"
                  />
                )}
              />
              <Button
                onClick={() => handleCheckBoxesToChangeState("changeStatus")}
                className="noBorderRadius inputsFont"
                variant="outlined"
                color="primary"
                sx={{ width: "auto" }}>
                Cambiar
              </Button>
            </Grid> */}

              {/*  Botones BUSCAR y LIMPIAR */}
              <Grid
                item
                xs={12}
                md={12}
                textAlign="center"
                sx={{
                  mt: "10px",
                  display: "flex",
                  gap: "5px",
                  justifyContent: "center",
                }}>
                <CustomButtonPlusIcon
                  icon={Search}
                  text="BUSCAR"
                  handleFunction={() => setSearch(!search)}
                  position="start"
                  variant="outlined"
                />
                <CustomButtonPlusIcon
                  icon={CleaningServices}
                  text="LIMPIAR FILTROS"
                  handleFunction={handleFilterStates}
                  position="start"
                  variant="outlined"
                  color="error"
                />
              </Grid>
            </Grid>
          )}

          <div style={{ position: "relative" }}>
            {flag && <LoadingPage isLoading={true} heightProp={"60vh"} />}

            {!flag && hasPermission && (
              <Table
                // selectableRowsComponent={Checkbox}
                columns={columns}
                data={contact}
                view={"contacto"}
                viewTitle={"contactos"}
                totalPagesNumber={totalPagesNumber}
                onSelectedRowsChange={setSelectedRowIds} // gestion de selección de contactos
                setChangeDone={setChangeDone}
                changeDone={changeDone}
                setSelectedRows={setSelectedRowIds}
                icon={PersonAdd}
                viewPermission={"contacts"}
                selectionActions={ChangeStatusBlock}
                apiRoute={"contacts"}
                checkBoxFlag
              />
            )}
            {!flag && totalPagesNumber > 10 && hasPermission && (
              <div className="tablePaginateContainer">
                <div className="paginatorLeftText">
                  Mostrando {objPerPage * (pagePressed - 1) + 1} a{" "}
                  {Math.min(objPerPage * pagePressed, totalPagesNumber)} de{" "}
                  {totalPagesNumber} resultados
                </div>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={<ChevronRight size={18} />}
                  previousLabel={<ChevronLeft size={18} />}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={flagToChangeStateHidePaginator ? 0 : pageCount}
                  containerClassName="pagination"
                  activeClassName="active"
                  pageClassName="page-item"
                  nextClassName="page-item"
                  previousClassName="page-item"
                  disabledClassName="disabled"
                  forcePage={pagePressed - 1} // Esto sincroniza el botón activo
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contactos;
